import { USER_MANAGEMENT_API } from './../../shared/constants/api-endpoint';
import { apiClient } from "shared/plugins/http-service";

export const getQrCode = async (userId:string) => {
  const createResponse = await apiClient.getHttp<string>(
    `${USER_MANAGEMENT_API}/${userId}/get_qr_code`,
  );
  return createResponse;
};

